export const GET_ALL_LOCATION_ENTITY = 'GET_ALL_LOCATION_ENTITY';
export const GET_ALL_LOCATION_SUB_ENTITY = 'GET_ALL_LOCATION_SUB_ENTITY';
export const GET_ALL_LOCATION_ENTERPRISE = 'GET_ALL_LOCATION_ENTERPRISE';
export const GET_ALL_LOCATION_ASSET = 'GET_ALL_LOCATION_ASSET';
export const FETCH_NESTED_CATEGORIES = 'FETCH_NESTED_CATEGORIES';
export const FETCH_NESTED_CATEGORY_ITEMS = 'FETCH_NESTED_CATEGORY_ITEMS';
export const FETCH_AOR = 'FETCH_AOR';